import {
  getImageBase64,
  getBackground
  , getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
  pathToBase64,
  isColor
} from '@/utils'

const nodule = async (data) => {
  const node = data.node;
  const color = data.color;
  const id = Math.random().toString(36).slice(-8);

  const background = await getBackground(data?.customTheme)

  return {
    id: id,
    elements: [
      {
        type: "text",
        id: "_l_TrXngiW",
        width: 552.4910236220472,
        height: 50.125,
        left: 62.64997375328084,
        top: 116.04398950131234,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 18.75px;font-family: Microsoft Yahei;font-weight: bold;">${node.children[0].title || ""
          }</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "uNx5pFz7mS",
        width: 552.4910236220472,
        height: 50,
        left: 62.64997375328084,
        top: 171.72304461942258,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 14.5px;font-family: Microsoft Yahei;">${node.children[0].text}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "1ouOFklcMR",
        width: 535.4664566929133,
        height: 50.125,
        left: 56.561154855643046,
        top: 323.91233595800526,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 18.75px;font-family: Microsoft Yahei;font-weight: bold;">${node.children[1].title || ""
          }</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "9_5H_4P3Du",
        width: 558.5799475065617,
        height: 50,
        left: 56.561154855643046,
        top: 381.0649868766404,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 14.5px;font-family: Microsoft Yahei;">${node.children[1].text}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "shape",
        id: "W5fGgA4z9R",
        width: 6.901837270341207,
        height: 6.901837270341207,
        left: 37.31653543307087,
        top: 29.14288713910761,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "zo2Dy5kyx_",
        width: 6.408818897637795,
        height: 6.408818897637795,
        left: 47.166089238845146,
        top: 28.900997375328085,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "lb6H3FuCkl",
        width: 6.127349081364829,
        height: 6.127349081364829,
        left: 56.52272965879265,
        top: 29.041784776902887,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "7W1roiSN-m",
        width: 5.678950131233596,
        height: 5.678950131233596,
        left: 65.59779527559056,
        top: 29.77742782152231,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "SktIrVmMDd",
        width: 5.3800524934383205,
        height: 5.3800524934383205,
        left: 74.22446194225721,
        top: 29.438530183727035,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "CJ9Gg3mqDM",
        width: 6.901837270341207,
        height: 6.901837270341207,
        left: 37.31653543307087,
        top: 38.80283464566929,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "aGBxjAAdar",
        width: 6.408818897637795,
        height: 6.408818897637795,
        left: 47.166089238845146,
        top: 38.560839895013125,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "ZFdlEaq2-P",
        width: 6.127349081364829,
        height: 6.127349081364829,
        left: 56.52272965879265,
        top: 38.70162729658793,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "W2n2I_K3yl",
        width: 5.678950131233596,
        height: 5.678950131233596,
        left: 65.59779527559056,
        top: 39.43737532808399,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "mpQomWOJgK",
        width: 5.3800524934383205,
        height: 5.3800524934383205,
        left: 74.22446194225721,
        top: 39.098372703412075,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "zvKM9OC2FG",
        width: 6.901837270341207,
        height: 6.901837270341207,
        left: 37.31653543307087,
        top: 48.462782152230965,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "XlZuVEVk0m",
        width: 6.408818897637795,
        height: 6.408818897637795,
        left: 47.166089238845146,
        top: 48.220787401574796,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "DaYDapBWtC",
        width: 6.127349081364829,
        height: 6.127349081364829,
        left: 56.52272965879265,
        top: 48.36157480314961,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "5VIlC6ZggF",
        width: 5.678950131233596,
        height: 5.678950131233596,
        left: 65.59779527559056,
        top: 49.09732283464567,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "TyDeGCGDhx",
        width: 5.3800524934383205,
        height: 5.3800524934383205,
        left: 74.22446194225721,
        top: 48.75832020997375,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "dw7i6YmGHL",
        width: 6.901837270341207,
        height: 6.901837270341207,
        left: 37.31653543307087,
        top: 58.122624671916014,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "RsyIbEdz6n",
        width: 6.408818897637795,
        height: 6.408818897637795,
        left: 47.166089238845146,
        top: 57.88073490813648,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "AcI-rS2vg8",
        width: 6.127349081364829,
        height: 6.127349081364829,
        left: 56.52272965879265,
        top: 58.02152230971128,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "gCb5-p0Fzu",
        width: 5.678950131233596,
        height: 5.678950131233596,
        left: 65.59779527559056,
        top: 58.75727034120735,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "3BzoYYjQlP",
        width: 5.3800524934383205,
        height: 5.3800524934383205,
        left: 74.22446194225721,
        top: 58.41826771653543,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "Y6j2bECaxH",
        width: 820.500997375328,
        height: 57.5,
        left: 89.74950131233598,
        top: 29.14288713910761,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><strong><span style="font-size: 25px;"><span style="font-family: 微软雅黑;font-weight: bold;">${node.title || ""
          }</span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "shape",
        id: "VwaAfrM2GG",
        width: 57.53511811023622,
        height: 10.088398950131234,
        left: 72.53984251968504,
        top: 487.4445144356955,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "_yshjD_Sy1",
        width: 10.088398950131234,
        height: 10.088398950131234,
        left: 68.2,
        top: 487.4445144356955,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "9OMoNtRH4V",
        width: 10.088398950131234,
        height: 10.088398950131234,
        left: 124.2,
        top: 487.4445144356955,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "hEg4_rf39-",
        width: 177.9841469816273,
        height: 177.9841469816273,
        left: 837.6499737532808,
        top: -105.70477690288713,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "C7wo3HCul9",
        width: 57.53511811023622,
        height: 10.088398950131234,
        left: 69.93763779527559,
        top: 296.69186351706037,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "WIj-hMyc8_",
        width: 10.088398950131234,
        height: 10.088398950131234,
        left: 65.59779527559056,
        top: 296.69186351706037,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "E7mg2E5qeY",
        width: 10.088398950131234,
        height: 10.088398950131234,
        left: 121.59779527559054,
        top: 296.69186351706037,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "line",
        id: "sh69o0Fj7W",
        width: 1.1250393700787402,
        left: 130.07496062992126,
        top: 494.53291338582676,
        start: [0, 0],
        end: [507.05175853018375, 0],
        style: "dashed",
        color: `${color}`,
        points: ["", ""],
      },
      {
        type: "line",
        id: "FauBxu5QqO",
        width: 1.1250393700787402,
        left: 127.4727559055118,
        top: 303.7802624671916,
        start: [0, 0],
        end: [507.05175853018375, 0],
        style: "dashed",
        color: `${color}`,
        points: ["", ""],
      },
    ],
    background,
  };
};

export default nodule;
